// extracted by mini-css-extract-plugin
module.exports = {"center":"LayoutCenter_center__F_Dxb","centerIntrinsic":"LayoutCenter_centerIntrinsic__qwpbs","container":"LayoutCenter_container__kpMiw","flex":"LayoutCenter_flex__bFS02"};